import * as React from "react";

import { FacetUrlCache } from "../plp-data-target-url-state";

import { useProductListData } from "./product-list-data-provider";

import {
  useProductListState,
  useProductListState_asController,
} from "./product-list-state-provider";

interface ProductListRunningCacheConsumerInterface {
  facetCache: FacetUrlCache;
}

const defaultValue = {} as unknown as ProductListRunningCacheConsumerInterface;

const ProductListRunningCacheContext = React.createContext(defaultValue);

export const ProductListRunningCacheProvider: React.FunctionComponent = (
  props
) => {
  const { data } = useProductListData();

  const { selectedOptions, facetDisplayNames } = useProductListState();
  const { setFacetDisplayNames } = useProductListState_asController();

  const facetCache = React.useMemo(() => {
    let updatedFacetDisplayNames = facetDisplayNames;
    for (const [key, facetDisplayName] of Object.entries(facetDisplayNames)) {
      const doesHaveAnyCorrespondingSelectedOptions = selectedOptions.some(
        ({ facetName }) => facetName === key
      );
      if (!doesHaveAnyCorrespondingSelectedOptions) {
        delete updatedFacetDisplayNames[key];
      }
    }
    setFacetDisplayNames(updatedFacetDisplayNames);
    return updatedFacetDisplayNames;
  }, [selectedOptions, data, facetDisplayNames]);

  const value: ProductListRunningCacheConsumerInterface = React.useMemo(
    () => ({
      facetCache,
    }),
    [facetCache]
  );
  return (
    <ProductListRunningCacheContext.Provider value={value}>
      {props?.children || []}
    </ProductListRunningCacheContext.Provider>
  );
};

export const useProductListRunningCache = () => {
  const context = React.useContext(ProductListRunningCacheContext);
  if (context === defaultValue) {
    throw new Error(
      "useProductListRunningCache must be used within a ProductListRunningCacheProvider"
    );
  }
  return context;
};
